export const DEFAULT_TEXT = 'Your widget is temporarily deactivated';
export const DEFAULT_TEXT_MINI = `${DEFAULT_TEXT}.`;

export const INTERACTIVE_DATA_ATTRIBUTE =
  'data-elfsight-interactive-deactivation';

export const WIDTH_LIMIT = 320;
export const HEIGHT_LIMIT = 160;

export const SHORT_WIDTH = 220;
export const SHORT_HEIGHT = 56;
export const SHORT_OVERLAY = 4;
